export default __webpack_public_path__ + "static/media/IcArrowRight.f3552956.svg";